import { API } from "@memberpoint/mp-frontend-core";

/**
 * A Manager that provides an interface to manager recordings..
 */
export class ClipManager extends API.SimpleAPIBaseManager {
  /**
   * Get a list of all non-deleted recordings.
   * @param {APIUrlBuilder} urlBuilder
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  getClips(urlBuilder) {
    let url = "/app/clips";
    urlBuilder.setUrl(url);
    return this.apiCall({ url: urlBuilder.generate() });
  }

  /**
   * Get a specific recording by its UUID
   *
   * @param id
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  getRecordingById(id) {
    let url = `/app/recordings/${id}`;
    return this.apiCall({ url });
  }

  /**
   * Update a specific recording by its UUID
   *
   * @param id
   * @param data
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  updateRecording(id, data) {
    let url = `/app/recordings/${id}`;
    data = { attributes: data };
    return this.apiCall({ url, method: "PUT", data });
  }

  /**
   * Remove a recording by its UUID
   *
   * @param id
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  removeRecording(id) {
    let url = `/app/recordings/${id}`;
    return this.apiCall({ url, method: "DELETE" });
  }

  /**
   * Get the data for a playlist file for the media player for a specific
   * recording.
   *
   * @param id The ID of the recording
   * @returns {Promise<SimpleAPIResponse | SimpleAPIResponse[]>}
   */
  getRecordingForPlayer(id) {
    let url = `/app/recordings/${id}/player`;
    return this.apiCall({ url });
  }
}
